$(document).ready(function(){
  $('#Option-template--15460663263368__main-1').on('change', function(){
    console.log($(this).val());
      var product = $('#MainProduct-template--15460663263368__main');
      if(product.length == undefined || product.length <= 0 || product == null){
        return;
      }
      var currentValue = $('#Option-template--15460663263368__main-1').val();
      var options = $('#Option-template--15460663263368__main-0').children();
    
      if($('#Option-template--15460663263368__main-1').val() == '3 Pack'){
          for(var i=0; i<options.length; i++){
            $('#Option-template--15460663263368__main-0').val('');
            if($(options[i]).attr('value') != '1 Mixed Berry 1 Tart Cherry and 1 Tropical Mango'){
                $(options[i]).prop('selected', false);
                // $(options[i]).hide();
            }else{
                $(options[i]).prop('selected', true);
                $(options[i]).show();
            }
          }
      }

      if($('#Option-template--15460663263368__main-1').val() == '1 Pack'){
          for(var i=0; i<options.length; i++){
            $('#Option-template--15460663263368__main-0').val('');
            if($(options[i]).attr('value') == '1 Mixed Berry 1 Tart Cherry and 1 Tropical Mango'){
                $(options[i]).prop('selected', false);
                $(options[i]).hide();
              console.log($(options[i]), $(options[i]).attr('value'));
            }else{
              $(options[i]).prop('selected', true);
              $(options[i]).show();
            }
          }
          $(options[0]).prop('selected', true);
      }  
  })
})